import { schema } from 'normalizr';

export const userSchema = new schema.Entity('users', {}, { idAttribute: 'UserId' });

export const userListSchema = [userSchema];
